var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebhooksinline = function SvgWebhooksinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6A6FF9",
    fillRule: "evenodd",
    d: "M12.051 11.534H4.918v.764a1.676 1.676 0 0 1-1.652 1.378 1.674 1.674 0 0 1-1.677-1.67c0-.569.286-1.071.722-1.373l-.48-.684A2.5 2.5 0 0 0 .75 12.006a2.51 2.51 0 0 0 2.516 2.505c1.246 0 2.28-.902 2.48-2.086h6.271a.839.839 0 0 0 1.565-.419.839.839 0 0 0-1.53-.472",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A6FF9",
    fillRule: "evenodd",
    d: "M2.516 11.66a.835.835 0 0 1 .772-.524L6.433 5.69a2.507 2.507 0 1 1 4.094-2.15l-.832.072a1.67 1.67 0 1 0-2.55 1.563l.46.266-3.561 6.17a.84.84 0 0 1 .015.688.836.836 0 1 1-1.543-.639",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A6FF9",
    fillRule: "evenodd",
    d: "m7.958 4.584 3.526 6.108.42-.243.007.013.01-.006a1.663 1.663 0 0 1 2.275.597c.457.791.18 1.807-.62 2.269a1.67 1.67 0 0 1-1.545.07l-.356.754c.714.33 1.577.318 2.315-.108 1.199-.692 1.615-2.216.93-3.403a2.49 2.49 0 0 0-3.055-1.067l-3.129-5.42a.825.825 0 0 0-1.144-1.11.825.825 0 0 0 .366 1.545",
    clipRule: "evenodd"
  })));
};
export default SvgWebhooksinline;